<template>
<w-sliding-popup ref="slidingPopup" title="맵 이미지 다운로드" width="350px">
  <div slot="content">
    <el-form :model="formData" :rules="rules" label-width="120px" ref="mapDownloadForm" label-position="top">
      <el-form-item label="이름" prop="fileName">
        <el-input v-model="formData.fileName"></el-input>
      </el-form-item>
    </el-form>
  </div>

  <div slot="footer">
    <el-button size="large" type="solid" @click="onSaveClick">저장</el-button>
    <el-button size="large" @click="close">취소</el-button>
  </div>
</w-sliding-popup>
</template>

<script>
import Base from '@/mixins/topologymap/base';
import MapConst from '@/constants/topologymap';
import { Q, MapInfo } from '@/views/topologymap/js/maps';

export default {
  name: 'WMapDownloadPopup',
  components: {
  },
  mixins: [Base],
  data() {
    return {
      formData: {
        fileName: '',
      },
      rules: {
        fileName: [
          {
            required: true,
            message: '파일 이름을 입력해주십시오.',
            trigger: 'blur',
          },
        ],
      },
    };
  },
  created() {
    this.$mapEventBus.$on(MapConst.MAP_EVENTBUS.MAP_DOWNLOAD, this.open);
  },
  beforeDestroy() {
    this.$mapEventBus.$off(MapConst.MAP_EVENTBUS.MAP_DOWNLOAD, this.open);
  },
  methods: {
    /**
     * 팝업 오픈 요청
     * @author KangBonghun(toto1323)
     * @param  {[type]} params [description]
     */
    open(params) {
      this.resetForm();
      this.initFormData(params.model);

      // this.$refs.slidingPopup.open();
      this.save();
    },
    /**
     * 팝업 닫기 요청
     * @author KangBonghun(toto1323)
     */
    close() {
      this.$refs.slidingPopup.close();
    },
    /**
     * 저장 버튼 클릭
     * @author KangBonghun(toto1323)
     */
    onSaveClick() {
      this.validateForm(); // 유효성 체크
    },
    /**
     * 유효성 체크
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    validateForm() {
      if (this.$refs.mapDownloadForm) {
        this.$refs.mapDownloadForm.validate((valid) => {
          if (valid) {
            // 유효성 체크를 통과하면 저장
            this.save();
          }
        });
      }
    },
    /**
     * 입력 폼 리셋
     * @author KangBonghun(toto1323)
     */
    resetForm() {
      if (this.$refs.mapDownloadForm) {
        this.$refs.mapDownloadForm.resetFields();
      }
    },
    /**
     * 폼 데이터를 초기화한다.
     * @author KangBonghun(toto1323)
     * @param  {[type]} model [description]
     * @return {[type]}       [description]
     */
    initFormData(model) {
      this.formData = {
        fileName: model.label,
      };
    },
    /**
     * 저장
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    save() {
      MapInfo.getInstance(this).exportImage((base64) => {
        if (base64) {
          const fileName = this.formData.fileName;

          if (Q.isIE) {
            return navigator.msSaveBlob(this.dataURItoBlob(base64), `${fileName}.png`);
          }

          const link = document.createElement('a');
          link.href = base64;
          link.download = fileName;
          document.body.appendChild(link);
          link.click();

          document.body.removeChild(link);

          this.close();
        }
        return false;
      });
      this.flashEffect(true);
      setTimeout(() => {
        this.flashEffect(false);
      }, 1000);
    },
    /**
     * dataURI를 Blob으로 변환하는 함수. 출처: https://goo.gl/46WtML
     */
    dataURItoBlob(dataURI) {
      // convert base64 to raw binary data held in a string
      // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
      const byteString = atob(dataURI.split(',')[1]);

      // separate out the mime component
      const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

      // write the bytes of the string to an ArrayBuffer
      const ab = new ArrayBuffer(byteString.length);
      const ia = new Uint8Array(ab);
      for (let i = 0; i < byteString.length; i += 1) {
        ia[i] = byteString.charCodeAt(i);
      }

      // write the ArrayBuffer to a blob, and you're done
      const bb = new Blob([ab], { type: mimeString });
      return bb;
    },
    flashEffect(on) {
      const el = document.querySelector('.graph-area');
      if (on) {
        el.classList.add('capture-flash');
      } else {
        el.classList.remove('capture-flash');
      }
    },
  },
};
</script>

<style module>
.v-middle {
  vertical-align: middle;
}
</style>
<style>
@keyframes flash {
 0% { opacity: .3; }
 100% { opacity: 1; }
}
.capture-flash {
  opacity: 1;
  animation: flash 1s;
}
</style>



// WEBPACK FOOTER //
// src/views/topologymap/components/popup/MapDownloadPopup.vue